import React from 'react';
import { Link } from 'react-router-dom';

// Navbar component
function Navbar() {
  return (
    // Container for the navbar, using Flexbox to align items
    <div className='container flex items-center justify-start m-auto text-black p-1 font-semibold'>
      {/* Logo link */}
      <Link to="/">
        {/* Logo image */}
        <img src="/icon.png" alt='logo' className='h-12'/>
      </Link>
      
      {/* Navigation links */}
      <div className='mx-4 flex gap-7 md:gap-7'>
        {/* NavLink component for the "Home" link */}
        <NavLink to ="/" label="Home"/>
        {/* NavLink component for the "Exercise" link */}
        <NavLink to ="/" label="Exercise" />
      </div>
    </div>
  );
}

// NavLink component
function NavLink({ to, label }) {
  return (
    // Link component from react-router-dom to navigate to the specified route
    <Link to ={to} className='capitalize cursor-pointer'>
      {/* Text label for the link */}
      {label}
    </Link>
  );
}

// Exporting the Navbar component to use in other parts of the application
export default Navbar;
